import { SmallBox } from '@app/components';
import { getDashboard } from '@app/services/auth';
import { getConvertedLeadsByParent } from '@app/services/lead';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { encode, decode } from 'js-base64'; 
import moment from 'moment';

const Dashboard = () => {
	
	const [data, setDashboardData] = useState([]);
	const [leads, setLeads] = useState([]);
	const [isLoading, setLoading] = useState(false);
    const canAccess = useSelector((state: any) => state.auth.permissions?.dashboard);
    const user = useSelector((state: any) => state.auth.currentUser);
    const role = useSelector((state: any) => state.auth.selectedRole);
    const student = useSelector((state: any) => state.auth.selectedStudent);

	useEffect(() => {
        getDashboardData();
		if(role?.slug == 'parent'){
			getConvertedLeads(user?.id)
		}
    },[]);

    const getDashboardData = async () => {
        try {
			setLoading(true);
            const resp = await getDashboard();
            if (resp.success === true) {
				setLoading(false);
				setDashboardData(resp.collections);
            } else {
				setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
			setLoading(false);
            toast.error(error.message);
        }
    };

	const getConvertedLeads = async (parent_id) => {
        try {
			setLoading(true);
            const resp = await getConvertedLeadsByParent(parent_id);
            if (resp?.success === true) {
				setLoading(false);
				setLeads(resp?.collections);
            } else {
				setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
			setLoading(false);
            toast.error(error.message);
        }
    };

	return (
		<div className="container-fluid">
			{/* Small Box (Stat card) */}
			{/* <h5 className="mb-2 mt-4">Small Box</h5> */}
			{ canAccess?.['statistics-overview'] && (
				<div className="row">
					<div className="col-lg-3 col-6">
						<SmallBox
							type="success"
							icon="fa-user-tag"
							count={ data['postcode'] }
							title="Active Postcodes"
							navigateTo="/postcodes"
							isLoading={isLoading}
						/>
					</div>
					<div className="col-lg-3 col-6">
						<SmallBox
							type="warning"
							icon="fa-briefcase"
							count={ data['franchise'] }
							title="Active Franchises"
							navigateTo="/franchise"
							isLoading={isLoading}
						/>
					</div>
					<div className="col-lg-3 col-6">
						<SmallBox
							type="info"
							icon="fa-briefcase"
							count={ data['centre']}
							title="Active Centres"
							navigateTo="/centers"
							isLoading={isLoading}
						/>
					</div>
				</div>
			)}
			{ !canAccess?.['statistics-overview'] && (
				<div className="row">
					<div className="col-md-12">
						<div className="card card-default">
							<div className="card-header">
								<h3 className="card-title">
									{/* <i className="fas fa-info" /> */}
									Welcome { user.first_name}
								</h3>
							</div>
							<div className="card-body">
								<div className="callout callout-info">
									<h5>Welcome { user.first_name +' '+ (user.last_name ?? '')}!</h5>
									<dt>Your Email:</dt>
									<dd>{ user.email }</dd>
									<dt>Your Mobile:</dt>
									<dd>{ user.phone }</dd>
									<p>You are logged in as a <b>{ role?.name }</b>.</p>
									{ role?.slug == 'parent' && user?.students?.length > 0 && student && Object.keys(student).length > 0 && (
										<p>You are viewing the details of the student - <b>{ student.first_name + ' ' + student.last_name }</b> </p>
									)}
								</div>
							</div>
						</div>
					</div>
					{ canAccess?.['student-applications'] && (
						<div className="col-md-6">
							<div className="card card-default">
								<div className="card-header">
									<h3 className="card-title">
										<i className="fas fa-clipboard" /> Recent Applications									
									</h3>
								</div>
								<div className="card-body">
									<div>
										{ leads.length > 0 ? leads.map((obj, i) => (
											<div key={i}>
											{ obj?.status != 'submitted' ? (
												<Link to={`/enrollment-form/${encode(obj?.lead_inquiry_student_id)}`}>
													<div className="app-item">
														<div className="app-info">
															<strong>{ obj?.first_name + ' ' + obj?.last_name}</strong>
															<span>{ obj?.subjects ? obj?.subjects.map.call(obj?.subjects, function(obj) { return obj.subject_name; }).join(", ") : '---'}</span>
														</div>
														<div className="status-date">
															<span className='status pending'>{ obj?.status ? obj?.status.charAt(0).toUpperCase() + obj?.status.slice(1) : "Pending"}</span>
															<div className="date">{ obj?.subjects ? moment(obj?.subjects[0]?.created_at).format('DD/MM/YYYY') : '---'}</div>
														</div>
													</div>
												</Link>
											) :(
												<div className="app-item">
													<div className="app-info">
														<strong>{ obj?.first_name + ' ' + obj?.last_name}</strong>
														<span>{ obj?.subjects ? obj?.subjects.map.call(obj?.subjects, function(obj) { return obj.subject_name; }).join(", ") : '---'}</span>
													</div>
													<div className="status-date">
														<span className={'status approved'}>{ obj?.status ? obj?.status.charAt(0).toUpperCase() + obj?.status.slice(1) : "Pending"}</span>
														<div className="date">{ obj?.subjects ? moment(obj?.subjects[0]?.created_at).format('DD/MM/YYYY') : '---'}</div>
													</div>
												</div>
											)}
											</div>
										)): (
											<span>There are no recent applications to display.</span>
										)}
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default Dashboard;